import React from 'react';
import { cities } from '../mock';
import { useI18n } from '../i18n';

const Cities = () => {
  const { t } = useI18n();
  return (
    <div className="pt-[72px] bg-white">
      <section className="bg-black text-white py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="text-[11px] tracking-[0.4em] uppercase text-white/60">Cities</p>
          <h1 className="font-serif text-5xl md:text-6xl mt-4 max-w-3xl">{t('cities.title')}</h1>
          <p className="text-white/70 mt-5 max-w-2xl">{t('cities.subtitle')}</p>
        </div>
      </section>
      <section className="py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {cities.map(c => (
            <div key={c.name} className="group relative overflow-hidden aspect-[4/5]">
              <img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              <div className="absolute bottom-5 left-5 text-white">
                <p className="font-serif text-2xl">{c.name}</p>
                <p className="text-xs text-white/70 tracking-widest uppercase">{c.country}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Cities;
